import { createElement, type ReactNode } from "react";

import AddIcon from "@/components/ui/icon/add";
import CalendarIcon from "@/components/ui/icon/calendar";
import EditDocumentIcon from "@/components/ui/icon/edit-document";

import { getSiteEmbedIifeUrl } from "@/components/features-new/settings-external-connection/site-embed/get-site-embed-iife-url";

import type { LangType, SiteEmbedVariant } from "../site-embed-preview/types";



export const VARIANT_LABEL_JA: Record<SiteEmbedVariant, string> = {
	button: "予約ボタン",
	form: "予約フォーム",
	calendar: "予約カレンダー",
};

export const SITE_EMBED_TAB_LIST: {
	label: string;
	type: SiteEmbedVariant;
	description: string;
}[] = [
	{
		label: "予約ボタン",
		type: "button",
		description:
			"クリックで予約フォームを開く要素には、ボタンやリンクなど、お好みのスタイルをご利用いただけます。",
	},
	{
		label: "予約フォーム",
		type: "form",
		description:
			"入力から予約確定までを、サイト上の指定位置にそのまま埋め込み表示します。",
	},
	{
		label: "予約カレンダー",
		type: "calendar",
		description:
			"空き状況をカレンダーで示し、日付を選んでから予約フローに進みます。まず日程を視覚的に見せたい場合に適しています。",
	},
];

export const LANG_OPTIONS: { label: string; value: LangType }[] = [
	{ label: "自動（推奨）", value: "default" },
	{ label: "日本語", value: "ja" },
	{ label: "英語", value: "en" },
];

export const VARIANT_ICONS: Record<SiteEmbedVariant, ReactNode> = {
	button: createElement(AddIcon, { size: "sm" }),
	form: createElement(EditDocumentIcon, { size: "sm" }),
	calendar: createElement(CalendarIcon, { size: "sm" }),
};

export const getMountTagSnippet = (variant: SiteEmbedVariant): string => {
	switch (variant) {
		case "button":
			return `<button data-chillnn-reservation-button-trigger>
  予約する
</button>`;
		case "form":
			return `<div data-chillnn-reservation-form></div>`;
		case "calendar":
			return `<div data-chillnn-reservation-calendar></div>`;
	}
};

export const getEmbedScriptSnippet = ({
	hotelID,
	lang,
}: {
	hotelID: string;
	lang: LangType;
}): string => {
	const scriptSrc = getSiteEmbedIifeUrl();
	const langLine = lang === "default" ? "" : `  data-chillnn-lang="${lang}"\n`;
	return `<!-- body タグの直前に配置してください -->
<script
  src="${scriptSrc}"
  data-chillnn-site-id="${hotelID}"
${langLine}></script>`;
};
